//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
let d=[[[0,"CycleFile",1,0],[0,"Description",1,0],[0,"DisplayName",1,0],[0,"ExpirationDate",1,0],[0,"OutputFolder",1,0],[0,"SoldToIDs",1,0]],[[[],"Publish",{},0,0],[["actionType","fn","command","filespec","parameters","directory"],"PerformCustomAction",{},6,0]],[]];
SPLM.CAM.MachineCycleManagerBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.MachineCycleManagerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.MachineCycleManagerBuilder.ButtonActionType = Object.freeze({
    "None" : "None", "UserFunction" : "UserFunction", "Execute" : "Execute", "ShellExecute" : "ShellExecute"});

export default SPLM;